import { useTranslation } from 'react-i18next';
import { CountBadge } from '@/shared/components';
import DocumentPdfIcon from '@/shared/assets/document-pdf-24-icon.svg?react';
import ChevRightIcon from '@/shared/assets/chev-right-24-icon.svg?react';

type Props = {
  count: number;
  onClick: () => void;
};

export const PendingInvoicesBar = ({ count, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-[5.6rem] w-full cursor-pointer items-center gap-[1.6rem] rounded-[1.6rem] border border-stroke-bg bg-background py-[1.6rem] pl-[2.4rem] pr-[1.6rem] text-left shadow-[0_0.4rem_0.4rem_0_rgba(0,0,0,0.04)] transition-colors hover:bg-secondary-bg">
      <DocumentPdfIcon className="size-[2.4rem] shrink-0 text-primary" />

      <span className="min-w-0 flex-1 truncate medium5 text-primary">
        {t('depositMethods.bankTransfer.invoices')}
      </span>

      <span className="flex shrink-0 items-center gap-[0.4rem]">
        <CountBadge count={count} />
        <ChevRightIcon className="size-[2.4rem] text-primary" />
      </span>
    </button>
  );
};
